module.exports = __webpack_public_path__ + "static/img/main-banner1-blue.e36c142.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main-banner1-blue.png
// module id = ylKT
// module chunks = 0